import React from 'react';
import { motion } from 'framer-motion';
import { ArrowUpRight } from 'lucide-react';

const DISCORD_URL = 'https://discord.gg/6Ft3VvHn';

const links = [
  { label: 'Features', href: '#features' },
  { label: 'How It Works', href: '#how-it-works' },
  { label: 'FAQ', href: '#faq' },
  { label: 'Docs', href: '/docs/', external: true },
];

export default function Navbar() {
  const [scrolled, setScrolled] = React.useState(false);
  const [menuOpen, setMenuOpen] = React.useState(false);

  React.useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const go = (e, href, external) => {
    if (external) {
      setMenuOpen(false);
      return;
    }
    e.preventDefault();
    setMenuOpen(false);
    document.querySelector(href)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <motion.nav
      data-testid="navbar"
      className={`navbar${scrolled ? ' navbar--scrolled' : ''}`}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5, delay: 0.05 }}
    >
      <div className="container nav-inner">
        <a
          href="/"
          className="nav-logo"
          onClick={(e) => { e.preventDefault(); window.scrollTo({ top: 0, behavior: 'smooth' }); }}
          data-testid="nav-logo"
        >
          bonk<span className="nav-logo-dot">.</span>
        </a>

        <div className="nav-center">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="nav-link"
              onClick={(e) => go(e, l.href, l.external)}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s/g, '-')}`}
            >
              {l.label}
            </a>
          ))}
        </div>

        <div className="nav-actions">
          <a
            href={DISCORD_URL}
            className="nav-discord"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="nav-link-discord"
          >
            Discord
          </a>
          <a
            href="#contact"
            className="nav-cta nav-cta-d"
            onClick={(e) => go(e, '#contact')}
            data-testid="nav-download-cta"
          >
            Join Waitlist <ArrowUpRight size={14} aria-hidden="true" />
          </a>
          <button
            type="button"
            data-testid="mobile-menu-btn"
            className="mob-btn"
            onClick={() => setMenuOpen(!menuOpen)}
            aria-expanded={menuOpen}
            aria-label={menuOpen ? 'Close menu' : 'Open menu'}
          >
            <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden="true">
              {menuOpen ? <path d="M16 4L4 16M4 4l12 12" /> : <path d="M3 7h14M3 13h14" />}
            </svg>
          </button>
        </div>
      </div>

      {menuOpen && (
        <motion.div
          className="nav-mobile-panel"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
        >
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="nav-mobile-link"
              onClick={(e) => go(e, l.href, l.external)}
              data-testid={`mobile-nav-link-${l.label.toLowerCase().replace(/\s/g, '-')}`}
            >
              {l.label}
            </a>
          ))}
          <a
            href={DISCORD_URL}
            className="nav-mobile-link"
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => setMenuOpen(false)}
            data-testid="mobile-nav-link-discord"
          >
            Discord
          </a>
          <a
            href="#contact"
            className="nav-mobile-cta"
            onClick={(e) => go(e, '#contact')}
            data-testid="mobile-nav-download"
          >
            Join Waitlist
          </a>
        </motion.div>
      )}
    </motion.nav>
  );
}
